/* eslint-disable react/jsx-key */
// Station
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext, useEffect, useMemo } from 'react'
import * as R from 'ramda'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
} from 'core'
import { connect } from 'react-redux'
import {
  getKindleIntegrationMapping,
  kindleMySqlFuelSave,
  kindleMySqlFuel,
} from 'api/pgads.js'
import CommonScreen from 'admin/component/CommonScreen'
import { Button, DatePicker, message, Select } from 'antd'

import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits, isValidYearRange } from 'core/utils'

import {
  DatePickerContext,
  ErrorContext,
  SpinContext,
  // UnitSelectionContext,
} from 'context'
import { CriteriaRow } from 'core/screen-util'
import { saveDataMessage } from 'kindle'

const headers = [
  dateCol({
    ident: 'period',
    display: 'Period',
    isFiltered: true,
    isEditable: false,
    sortOrder: 'asc',
  }),
  numCol({
    displayFormat: '0.0000',
    ident: 'price',
    display: 'Price',
    isFiltered: true,
    isEditable: false,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'instrumentId',
    display: 'Instrument Id',
    isFiltered: true,
    isEditable: false,
    width: 400,
    sortOrder: 'asc',
  }),
]

const Fuel = ({ title = 'Fuel', units, apiTargetInfo, ...props }) => {
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const [integrationUnits, setIntegrationUnits] = useState([])
  const [selNames, setSelNames] = useState(['all'])
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  useEffect(
    _ => {
      getKindleIntegrationMapping(apiTargetInfo).fork(
        setError,
        integrationMapping => {
          const filteredIntegrationMapping = integrationMapping
            .filter(u => u.unitId)
            .filter(u => u.importType === 'FUEL')
            .map(k => k.kindleName)
          /// const newUnitList = units.filter(u => unitIds.includes(u.unitId))
          setIntegrationUnits(R.uniq(filteredIntegrationMapping))
        }
      )
    },
    [apiTargetInfo, setError, units]
  )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: integrationUnits,
    units: integrationUnits,
    // itemToLabel: e => e.emktId,
  })

  const { authGodMode } = props.envConfig

  const actionPermits = props.actionPermits

  const kindleMySqlGenerationWritePermisiion = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.KINDLE_MYSQL_DA_AWARD_ADMIN],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const withCriteria = (_, _2, su, sd) => {
    return {
      date: sd,
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      ids:
        selNames.length === 0 || selNames.includes('all')
          ? integrationUnits
          : selNames,
    }
  }

  // const screenCriteria = (s, p, u, onChange) => {
  //   return (
  //     <DatePicker.RangePicker
  //       style={{ marginLeft: '15px' }}
  //       allowClear={false}
  //       format="MM/DD/YYYY"
  //       value={selectedDateRangePicker}
  //       onChange={d => {
  //         setSelectedDateRagePicker(d)
  //         onChange()
  //         // retrieve({ dates: d })
  //       }}
  //     />
  //   )
  // }

  const saveData = _ => {
    // const unitIds = integrationUnits.map(u => u.unitId)
    // const newUnitList = units.filter(u => unitIds.includes(u.unitId))
    // const unitnames = selectedUnits
    //   .filter(u => unitIds.includes(u.unitId))
    //   .map(u => u.unitName)

    setSpinning(true)
    kindleMySqlFuelSave(apiTargetInfo)({
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      ids:
        selNames.length === 0 || selNames.includes('all')
          ? integrationUnits
          : selNames,
    }).fork(setError, _ => {
      setSpinning(false)
      // message.info('Data saved')
      saveDataMessage()
    })
  }

  const extraCriteriaAfterButton = _ => {
    if (kindleMySqlGenerationWritePermisiion)
      return (
        <Button type="danger" onClick={saveData} loading={spinning} icon="save">
          Save Remote Data
        </Button>
      )
    return <div />
  }

  const beforeRetrieveValidation = ({ validYearRange }) => {
    if (integrationUnits.length === 0) {
      message.warning('Please, Select Locations')
      return false
    }
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  const extraCriteria = ({ onCriteriaChnage }) => (
    <CriteriaRow
      css={{
        display: 'grid',
        gridTemplateColumns: '130px auto',
        paddingTop: '0px',
      }}
    >
      <div>Select Location : </div>
      <Select
        style={{ width: '100%' }}
        placeholder="Select Location"
        onChange={val => {
          setSelNames(val)
          onCriteriaChnage()
        }}
        mode="multiple"
        value={selNames}
        allowClear
      >
        <Select.Option key="all">All</Select.Option>
        {integrationUnits.map(i => (
          <Select.Option key={i} value={i}>
            {i}
          </Select.Option>
        ))}
      </Select>
    </CriteriaRow>
  )

  return (
    <React.Fragment>
      <CommonScreen
        retrieveLabel="Retrieve Remote Data"
        beforeRetrieveValidation={beforeRetrieveValidation}
        extraCriteria={extraCriteria}
        screenCriteria={screenCriteria}
        extraUnitSelectionProps={extraUnitSelectionProps}
        extraCriteriaAfterButton={extraCriteriaAfterButton}
        title={title}
        titleProps={{ minWidth: '100px' }}
        header={headers}
        retrieveTask={kindleMySqlFuel}
        withCriteria={withCriteria}
        insertComp={false}
        insertCompHeight={90}
        heightOffset={270}
        allowInsert={false}
        isAdminScreen={false}
        withoutModify
        withDelete={false}
        isEditableGrid={_ => false}
        totalWidth={800}
        sortOptions={headers}
        initialSortOptions={headers}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(Fuel)
